import React, { Component, useState, Fragment } from "react";
import { Modal, Button, Form, Table, Row, Col } from "react-bootstrap";
import InputGroup from 'react-bootstrap/InputGroup';
import 'bootstrap/dist/css/bootstrap.min.css';
import Switch from 'react-bootstrap/Switch';
import Cookies from 'js-cookie'
import settings from '../../assets/settings.json';
import Spreadsheet, { createEmptyMatrix } from "react-spreadsheet";
import '../css/create_order.css';


export default class CreateOrder extends Component{
  
  constructor(){
    super();

    let sashimodoshi_table_data = [[{ value: "管理番号"}, { value: "明細行"}, { value: "数量"}, { value: "JAN"}, { value: "型番"}, { value: "色番"}, { value: "サイズ番"}, { value: "問屋ファイル名"}]];
    let s =0;
    while(s<30){
      sashimodoshi_table_data.push([{ value: "" }, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}]);
      s++;
    };


    let st_table_data = [[{ value: "商品コード"}, { value: "商品名"}, { value: "発注数"}, { value: "問屋ファイル名"}, { value: "販売価格"}]];
    let i =0;
    while(i<30){
      st_table_data.push([{ value: "" }, { value: ""}, { value: ""}, { value: ""}, { value: ""}]);
      i++;
    };

    let unspecified_table_data = [[{ value: "JAN"}, { value: "発注数"}]];
    let u =0;
    while(u<30){
      unspecified_table_data.push([{ value: "" }, { value: ""}]);
      u++;
    };

    this.state={
      isOpen: false,
      st_table_data: st_table_data,
      sashimodoshi_table_data:sashimodoshi_table_data,
      unspecified_table_data:unspecified_table_data,
      table_data: sashimodoshi_table_data,
      //authObj:{},
      isit_post:false,
      radio_select:'sashimodoshi',
      radioButtons:[{label:'差し戻し', value:'sashimodoshi'},{label:'ST-', value:'st'},{label:'問屋指定なし', value:'unspecified'}],
      show_tonya_list:false,
      unspecified_memo:''
    }
  }

  
  componentDidMount () {
    //let staff_token = Cookies.get('_replace_token');
		//let staff_name = Cookies.get('_replace_staff');
		//this.setState({authObj:{"token":staff_token, "name":staff_name}})
  }
  
  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });
  closeModalShowTonya = () => this.setState({show_tonya_list:false});
  

  submitModal = async (e) => {
    console.dir(e.target);
    let trs = null;
    if(this.state.radio_select!=='unspecified'){
      trs = e.target.parentElement.childNodes[1].childNodes[0].childNodes[1].childNodes;  
    }else{
      trs = e.target.parentElement.childNodes[2].childNodes[0].childNodes[1].childNodes;
    }
    
    let item_array = [];
    let error_array = [];
    //console.dir(trs[3]);
    for (let i = 0; i < trs.length; i++) {
      if(trs[i].childNodes[1].innerText!=='A' && trs[i].childNodes[1].innerText!=='商品コード' && trs[i].childNodes[1].innerText!=='管理番号' && trs[i].childNodes[1].innerText!=='' && trs[i].childNodes[1].innerText!=='JAN'){
        let item_obj = {};
        let which_tonya = '';
        let isit_ok_tonya_f_name = false;

        if(this.state.radio_select==='st'){
          item_obj['item_code'] = trs[i].childNodes[1].innerText;
          item_obj['item_name'] = trs[i].childNodes[2].innerText;
          item_obj['howmany'] = trs[i].childNodes[3].innerText;
          item_obj['which_tonya'] = trs[i].childNodes[4].innerText;
          item_obj['setting_price'] = trs[i].childNodes[5].innerText;
          which_tonya = trs[i].childNodes[4].innerText;
        }else if(this.state.radio_select==='sashimodoshi'){
          item_obj['cm_order_no'] = trs[i].childNodes[1].innerText;
          item_obj['meisai_gyou'] = trs[i].childNodes[2].innerText;
          item_obj['howmany'] = trs[i].childNodes[3].innerText;
          item_obj['JAN'] = trs[i].childNodes[4].innerText;
          item_obj['item_type'] = trs[i].childNodes[5].innerText;
          item_obj['color_type'] = trs[i].childNodes[6].innerText;
          item_obj['size_type'] = trs[i].childNodes[7].innerText;
          item_obj['which_tonya'] = trs[i].childNodes[8].innerText;
          which_tonya = trs[i].childNodes[8].innerText;
        }else if(this.state.radio_select==='unspecified'){
          item_obj['JAN'] = trs[i].childNodes[1].innerText;
          item_obj['howmany'] = trs[i].childNodes[2].innerText;
          isit_ok_tonya_f_name = true;
        }


        
        for (let iii = 0; iii < this.props.data.tonya_datas.length; iii++) {
          if(this.props.data.tonya_datas[iii].tonya_name_f===which_tonya){
            isit_ok_tonya_f_name = true;
          }
        }


        //console.dir(item_obj);
        if(isit_ok_tonya_f_name===true){
          item_array.push(item_obj);
        }else{
          error_array.push(JSON.stringify(item_obj));
        }
        
      }
    }

    console.dir(item_array);
    console.dir(error_array);

    if(error_array.length>0){
      let error_string = error_array.join('\n');
      let alert_box = window.confirm('処理できないデータがありました。\n進めてもいいですか？\n\n'+error_string);
      if(alert_box===false){
        return 'check_false';
      }
    }



    console.dir(item_array);

    let post_data = {};
    if(this.state.radio_select!=='unspecified'){
      post_data = {"data":item_array};
    }else{
      post_data = {"data":item_array, "keyword":this.state.unspecified_memo};
    }
    

    if(item_array.length>0){
      this.setState({isit_post:true});

      fetch(settings.API_BASE_URL+'create_hattyuu_item/' + '?token=' + this.props.data.auth_obj.token + '&name='+ this.props.data.auth_obj.name +'&what_type='+this.state.radio_select , {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(post_data)
      })
      .then(response => response.json())
      .then(data => {
        console.dir(data)
        let res_obj = data.data.obj;
        if(res_obj.length>0){
          let text = '';
          for (let i = 0; i < res_obj.length; i++) {
            if(i===0){
              text = res_obj[i];
            }else{
              text = text + '\n' + res_obj[i];
            }
          }
          alert(text);
        }

        this.setState({isit_post:false});
      })
      .catch(error => {
        console.error(error)
        alert(error);
        this.setState({isit_post:false});
      });

    }




  }
  
    
  render(){
    var radioChangeValue = async (e) => {
      console.dir(e.target.value);
      if(e.target.value==='sashimodoshi'){
        this.setState({table_data:this.state.sashimodoshi_table_data});
      }else if(e.target.value==='st'){
        this.setState({table_data:this.state.st_table_data});
      }else if(e.target.value==='unspecified'){
        this.setState({table_data:this.state.unspecified_table_data});
      }

      this.setState({radio_select:e.target.value});
    }


    var handleTableInputChange = async (e) => {
      console.dir(e.target);

    }

    var submit_add_table = async (e) =>{
      //console.dir(e.target);
      let tr_elems = document.getElementsByClassName('paste-table')[0].childNodes[0].childNodes[1].childNodes;
      console.dir(tr_elems);
    }


    var tonyaFileListClick = async (e) => {
      this.setState({show_tonya_list:true});
    }


    let modal_class = '';
    let modal_button_class = '';
    if(this.state.isOpen===true){
      modal_class = 'position-relative create-hattyuu-irai';
      modal_button_class = 'download-button-hidden';
    }else{
      modal_class = 'download-button-hidden';
      modal_button_class = 'btn btn-sm btn-secondary  a-small';
    }

    
    if(this.state.isit_post===true){
      modal_button_class = modal_button_class+' opacity-50';
    }



    var handleInputChange = async (e) => {
      this.setState({unspecified_memo:e.target.value})
    }



    return (
    
      <div className="create-order-elem">
        
        {this.props.data.isit_now_data_importing ? 
          <button className={modal_button_class} disabled>取込中,作成不可</button> : 
          <button className={modal_button_class} onClick={this.openModal}>発注依頼の作成</button>
        }

        <div className={modal_class}>

          <div className="row mb-15 text-center">
            <div className="col-2">依頼タイプ</div>
  
            {this.state.radioButtons.map((radio, index) => {
              return (
                <div className="col-2" key={'radio_'+String(index)}>
                    {/* checked属性に式を定義する */}
                    <input className="form-check-input mx-2" type="radio" name="what_type" 
                        value={radio.value} checked={radio.value === this.state.radio_select} onChange={event=>radioChangeValue(event)}/>
                    <label className="form-check-label">
                        <span className="fs-6">{radio.label}</span>
                    </label>
                </div>
              )
            })}

            <div className="col-2">
              <button className="btn btn-sm btn-outline-secondary a-small" onClick={event=>tonyaFileListClick(event)}>問屋ファイル名リスト</button>
            </div>

          </div>

          {this.state.radio_select==='unspecified' ? 
            <>
              <Row>
                <Col>
                  <InputGroup size="sm" className="mb-3">
                    <InputGroup.Text>受注店舗名</InputGroup.Text>
                    <Form.Control
                      aria-label="Small"
                      type="text"
                      maxLength="50"
                      name="create_order_memo"
                      placeholder="Shopee など, 英数字は半角！"
                      value={this.state.unspecified_memo}
                      onChange={event=>handleInputChange(event)}
                    />
                  </InputGroup>
                </Col>
              </Row>

            </>
           : <></>}
         


          <Spreadsheet 
            data={this.state.table_data} 
            className="paste-table" 
            id="create_hattyuu_list" 
          />
          <br />
          <div className="position-absolute bottom-0 end-0 btn btn-primary modal-submit-button" onClick={this.submitModal}>
            {this.state.isit_post===false ? '送信する' :   <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></>}
            
          </div>	

          <div className="jan-info-close-button" onClick={this.closeModal}><i className="bi bi-x-circle"></i></div>	



          <div className="small">
            {this.state.radio_select==='sashimodoshi' ? 
              <>
                問屋引き当てなし、欠品分の 管理番号、JAN に問屋ファイル名を割り当てます。在庫データ内の在庫数は変動しません。
              </> 
            : <></>}

            {this.state.radio_select==='st' ? 
              <>
                st用の仮想注文データを作成します。指定発注数より在庫データ数が少ない場合は、在庫数分引き当たります。<br/>不足分はスルーされます。<br/>
                商品コード st- 、もしくは管理番号 9 から始まる行を確認ください。
              </> 
            : <></>}

            {this.state.radio_select==='unspecified' ? 
              <>
                任意の注文データを作成します。指定発注数より在庫データ数が少ない場合は、在庫数分引き当たります。<br/>不足分はスルーされます。<br/>
                管理番号 S から始まるデータが作成されます。<br/>
              </> 
            : <></>}
          </div>


          {this.state.show_tonya_list ? 
            <>
              <div className="show_tonya_list">
                <table>
  				      	<thead>
  				      		<tr className="table-row sticky-top bg-secondary text-white">
  				      			<td className="table-col">No.</td>
  				      			<td className="table-col nowrap td-relative">問屋ファイル名</td>
                      <td className="table-col nowrap">簡略名称</td>
  				      		</tr>
  				      	</thead>
                  <tbody>
                    {this.props.data.tonya_datas.map((row, index)=>{
                      return(
                        <tr key={'show_t_'+row.id} className="">
                          <td>{index+1}</td>
                          <td className="table-col nowrap">{row.tonya_name_f}</td>
                          <td className="table-col nowrap">{row.tonya_name}</td>
                        </tr>
                      )
                    })}  
                  </tbody>
                </table>
                <div className="tonya-f-list-close-button text-white" onClick={this.closeModalShowTonya}><i className="bi bi-x-circle"></i></div>	
              
              
              
              </div>	
            
            </> : <></>
          }

        </div>

        {/* <Spreadsheet data={this.state.table_data} onChange={handleTableInputChange}/> */}
        

      </div>
    );
  }
}
  
  

	//{...this.props}